import styled from 'styled-components';

export const StyledUserPanelResultsIcons = styled.div`
    min-height: 30px;
    display: flex;
    align-items: center;
`;
